import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormControl, FormGroup, ReactiveFormsModule, Validators
} from '@angular/forms';

import { IrisButtonModule, IrisButtonTypes } from '@sondermind/iris/button';
import { IrisCardModule } from '@sondermind/iris/card';
import { IrisIconModule } from '@sondermind/iris/icon';
import { IrisRadioGroupModule, RadioOption } from '@sondermind/iris/radio-group';
import { ILocation } from '@sondermind/utilities/models-public-facing';
import { SessionType } from '@sondermind/utilities/models-session';

import { AppointmentCarouselComponent } from '../appointment-carousel/appointment-carousel.component';
import { ProviderTimeZoneStringPipe } from './provider-timezone-string-pipe/provider-timezone-string.pipe';
import { IProviderCalendarForm } from '../../models/provider-calendar-form.model';
import { IAppointmentForCarousel } from '../appointment-carousel/appointment-carousel.interface';

const inPersonSessionOption: RadioOption<string> = {
  name: 'I\'d prefer an in-person session',
  value: SessionType.IN_PERSON,
  iconName: 'location_on',
  iconColor: '$color-dec-kelly-100',
};

@Component({
  selector: 'public-provider-calendar',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    IrisButtonModule,
    IrisCardModule,
    IrisIconModule,
    IrisRadioGroupModule,
    AppointmentCarouselComponent,
    ProviderTimeZoneStringPipe,
  ],
  templateUrl: './provider-calendar.component.html',
  styleUrls: ['./provider-calendar.component.scss'],
})
export class ProviderCalendarComponent implements OnInit {
  @Input() providerFirstName: string = '';
  @Input() providerTimeZone: string = '';
  @Input() providerPrimaryAddress: ILocation | null = null;
  @Input() providerSessionTypesOffered: string[] = [];

  showSessionType: boolean = false;
  irisButtonTypes = IrisButtonTypes;
  addressStr = '';

  providerCalendarFormGroup: FormGroup<IProviderCalendarForm> = new FormGroup<IProviderCalendarForm>({
    sessionTypePreference: new FormControl<SessionType | null>(null),
    appointment: new FormControl<IAppointmentForCarousel | null>(null)
  });

  sessionTypeOptions: Array<RadioOption<string>> = [
    {
      name: 'I\'d prefer a video session',
      value: SessionType.VIDEO,
      iconName: 'videocam',
      iconColor: '$color-dec-kelly-100'
    },
    inPersonSessionOption,
    {
      name: 'I don\'t have a preference',
      value: '',
    }
  ];

  ngOnInit(): void {
    this.showSessionType = this.handleSessionTypeRadio();
  }

  private handleSessionTypeRadio(): boolean {
    if (this.providerSessionTypesOffered.length > 1) {
      this.providerCalendarFormGroup.controls.sessionTypePreference.setValidators(Validators.required);
      if (this.providerPrimaryAddress) {
        // eslint-disable-next-line max-len
        this.addressStr = `${this.providerPrimaryAddress?.address_line1}, ${this.providerPrimaryAddress?.city} ${this.providerPrimaryAddress?.state}, ${this.providerPrimaryAddress?.postal_code}`;
        inPersonSessionOption.details = this.addressStr;
      }
      return true;
    }

    return false;
  }
}
